export enum SectorViewMode {
  Details = 'details',
  Sites = 'sites',
  Users = 'users',
  Create = 'create',
  Edit = 'edit',
}
